//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  name: 'rb-file-attachment',
  props: {
    imageFormats: {
      type: Array,
      default: () => [],
    },
    inputFileValidFormats: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      attachmentName: '',
      attachmentSize: 0,
      attachmentType: '',
      fileInputKey: 0,
    }
  },
  computed: {
    ...mapGetters(['translation']),

    canShowFileInputErrorMessage() {
      return this.isInvalidUploadedFile
    },

    fileInputIconClass() {
      return this.isFileImg ? 'common__icon--file-img' : 'common__icon--file-pdf'
    },

    getAttachmentSize() {
      return `[${this.attachmentSize} MB]`
    },

    isFileAdded() {
      return this.attachmentName && this.attachmentSize && this.attachmentType
    },

    isFileIconVisible() {
      return this.isFileAdded && !this.isInvalidUploadedFile
    },

    isFileImg() {
      return this.imageFormats.includes(this.attachmentType)
    },

    isInvalidUploadedFile() {
      return this.isFileAdded && (!this.isValidFormatFile || this.attachmentSize > 2)
    },

    isValidFormatFile() {
      return this.inputFileValidFormats.includes(this.attachmentType)
    },
  },
  methods: {
    forceRerenderFileInput() {
      this.fileInputKey += 1
    },

    onFileInputChange() {
      const input = this.$refs.fileAttachment
      const file = input.files[0]

      if (file) {
        const fileSize = file.size
        const fileSizeMB = (fileSize / (1024 * 1024)).toFixed(2)
        this.attachmentName = file.name
        this.attachmentSize = +fileSizeMB
        this.attachmentType = file.type
        const reader = new FileReader()
        reader.onload = (event) => {
          const base64Data = event.target.result.split(',')[1]
          this.$emit('changedFileInput', {
            attachmentName: this.attachmentName,
            attachmentBase64: base64Data,
          })
        }
        reader.readAsDataURL(file)
      }
      this.$emit('fileInputError', this.isInvalidUploadedFile)
    },

    onFileRemove() {
      this.resetInputFile()
      this.forceRerenderFileInput()
      this.$emit('fileInputError', false)
    },

    resetInputFile() {
      this.attachmentName = ''
      this.attachmentSize = 0
      this.attachmentType = ''
    },
  },
}
